import styles from './app.module.scss';
import { environment } from '../environments/environment';
import { useContext, useEffect, useMemo, useState } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { GetRoles, TokenProvider } from 'libs/webkua-lib/src/lib/TokenContext';
import axios from 'axios';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement } from 'chart.js';
import {
  ActiveUsers, ExpiredLicense, FailedLogin, LicenseUsage, LicenseUsageSummary, MainMenu, MenuItemInterface, NewSales, Nlm, Overview, PersonActivity,
  ProductStructure, RejectedLogin, Renewals, WebUpdates, ContactListProvider, ContractDetailsContainer, CustomerDetails, Support, CustomerProductList,
  ProductVersion, Contracts, FutureRenewals, AllContracts, CompanyRequests, GPTOverview,
  SignalRProvider, NewContractContainer, HeaderBar, SecretPage1, SearchBar, AdminChangeContract, AdminCompany, SupportReport, Courses,
  ValidateEmail, MinSideStatus, MonthlyReportContainer, GetCurrentCompany, EmailContainer, EditEmail, CreateEmail, RelationProductProvider, ProductUsageChart, SalesChart, ChurnChart, BronnoysundAdmin, Catalog, Course, Resources, InformationTexts, Registration, EmailTemplates, Reports, LicenseAccess, Licenses, Users,
  SalesOffer,
  SalesPersonOverviewContainer,
  UseSignalRHook,
  ContactListUpdateContext,
  SalesForceFailedOrders,
  SalesForceAssetSync,
  SalesForceAccountReconciliationPage
} from '@frontend-workspace/webkua-lib';

import { StyledEngineProvider } from '@mui/styled-engine';
import { Box, Container, Drawer, Icon, Paper, BreakpointsProvider, SnackBarContext, SnackBarMessage, Snackbar, Alert, AlertType, CreateRoute, Roles, ToggleButtonGroup, ToggleButton, OrderTypesEnum, IContactType, IWebkuaSignalRResponse } from '@frontend-workspace/react-shared-lib';

import { useTranslation } from 'react-i18next';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { makeRequest } from 'libs/webkua-lib/src/lib/requestUtils';

function App() {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    BarElement,
    PointElement,
    Title,
    Tooltip,
    Legend
  );
  const [snackbarMessage, setSnackbarMessage] = useState<SnackBarMessage>();
  const [newCompanyDialogOpen, setnewCompanyDialogOpen] = useState(false);
  const snackbarHandlingValue = useMemo(
    () => ({ snackbarMessage, setSnackbarMessage }),
    [snackbarMessage]
  );
  const handleNewCompanyToggle = () => setnewCompanyDialogOpen(!newCompanyDialogOpen);
  const { login, result, error } = useMsalAuthentication(InteractionType.Redirect);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer = (event: any) => {
    setDrawerOpen(!drawerOpen);
  };
  // useEffect(() => {
  //   const prevInterceptors = axios.interceptors.response as any;
  //   if (prevInterceptors.handlers.length > 0) { return; }

  //   const errorInterceptor = axios.interceptors.response.use(function (response) {
  //     return response;
  //   }, function (error) {
  //     console.log("ErrorInterceptor", error);
  //     if (error.response) {
  //       console.error('Response Error', error.response, error.response.status, error.response.status === 403);
  //       if (error.response.status === 403) {
  //         console.log("test");
  //         setSnackbarMessage({ content: "Du har ikke tilgang til denne siden", type: 'error' })
  //       };
  //       if (error.response.data) { setSnackbarMessage({ content: error.response.data, type: 'error' }) };
  //     } else if (typeof error.response === 'undefined') {
  //       if (!axios.isCancel(error)) {
  //         console.error('Network Error', error);
  //         setSnackbarMessage({ content: error.response, type: 'error' });
  //       }
  //     } else if (error.request) {
  //       console.error('Request Error', error.request);
  //     } else {
  //       console.error('Uncaught Error', error.message);
  //     }
  //     return Promise.reject(error);
  //   });

  //   return () => {
  //     axios.interceptors.request.eject(errorInterceptor);
  //   }
  // }, []);

  return (
    <>
      <AuthenticatedTemplate>
        <TokenProvider>
          <StyledEngineProvider injectFirst>
            <BreakpointsProvider>
              <SnackBarContext.Provider value={snackbarHandlingValue}>
                <SignalRProvider>
                  <ContactListProvider>
                    <RelationProductProvider>
                      <HeaderBar toggleDrawer={toggleDrawer} />
                      <SearchBar salesforceBaseUrl={environment.salesforce_url} />
                      <Container disableGutters className='container-fluid px-0' maxWidth={false}>
                        <div className={`${styles.customContainer}`}>
                          <Paper elevation={0}>
                            <AppContent
                              drawerOpen={drawerOpen}
                              onToggleDrawer={toggleDrawer} />
                          </Paper>
                        </div>
                      </Container>
                      <Snackbar
                        open={!!snackbarMessage}
                        autoHideDuration={snackbarMessage?.type === 'error' ? undefined : snackbarMessage?.duration || 15000}
                        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                        onClose={() => { setSnackbarMessage(undefined) }}>
                        <div>
                          <Alert
                            icon={snackbarMessage?.userId ? <Icon>language</Icon> : null}
                            onClose={snackbarMessage?.type === 'error' ? () => { setSnackbarMessage(undefined) } : undefined}
                            severity={snackbarMessage?.type as keyof typeof AlertType}
                            variant='filled'
                            color={snackbarMessage?.type as keyof typeof AlertType}
                            closeText='Lukk'
                            sx={{ minWidth: '250px' }}>
                            {snackbarMessage?.content}
                          </Alert>
                        </div>
                      </Snackbar>
                    </RelationProductProvider>
                  </ContactListProvider>
                </SignalRProvider>
              </SnackBarContext.Provider>
            </BreakpointsProvider>
          </StyledEngineProvider>
        </TokenProvider >
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        {/* anything added here that will only be displayed briefly before being redirect to login page*/}
      </UnauthenticatedTemplate>
    </>
  )
}

export function AppContent(props: {
  drawerOpen: boolean,
  onToggleDrawer: (...args: any[]) => void
}
) {
  const userRoles = GetRoles();
  const [showHiddenItems, setShowHiddenItems] = useState(false);
  const { t } = useTranslation();
  const setCustomers = useContext(ContactListUpdateContext);
  const handleNewCompanySignal = (response: IWebkuaSignalRResponse) => {
    makeRequest("companies").then((customers: IContactType[]) => setCustomers && setCustomers(customers));
  };

  UseSignalRHook(handleNewCompanySignal, [OrderTypesEnum.NewCompany, OrderTypesEnum.NewCompanyWithoutAdminOrder, OrderTypesEnum.SFCreateCompanyOrder, OrderTypesEnum.SFUpdateCompanyOrder]);
  const [menuItems, setMenuItems] = useState<Array<MenuItemInterface>>([
    {
      text: t("app.customers"),
      icon: <Icon className='material-icons-outlined' color="action">group</Icon>,
      defaultOpen: true,
      id: "0",
      requiredRole: Roles.User,
      subCategories: [
        { text: t("app.customerDetails"), url: "/customers/details" },
        { text: t("app.contracts"), url: "/customers/all-contracts" },
        { text: t("app.userSupport"), url: "/customers/support" },
        { text: t("app.productList"), url: "/customers/product-list" },
        { text: t("app.offers"), url: "/customers/proposals", hiddenByDefault: true },
        { text: t("app.assetSync"), url: "/customers/assetSync" },
        // { text: t("app.autodeskOpportunities"), url: "/customers/opportunities" }
      ]
    }, {
      text: t("mainMenu.licensing"),
      icon: <Icon className='material-icons-outlined' color="action">inventory_2</Icon>,
      defaultOpen: true,
      id: "1",
      requiredRole: Roles.User,
      subCategories: [
        { text: t("app.activeUsers"), url: "/licenses/active-users" },
        { text: t("app.loginFailed"), url: "/licenses/failed-login" },
        { text: t("app.rejectedLogin"), url: "/licenses/rejected-login", hiddenByDefault: true },
        { text: t("app.licenseExploitation"), url: "/licenses/license-usage", hiddenByDefault: true },
        { text: t("app.personActivity"), url: "/licenses/person-activity", hiddenByDefault: true },
        { text: t("app.licenseChanges"), url: "/licenses/license-changes", hiddenByDefault: true },
        { text: t("app.licenseAccess"), url: "/licenses/license-access", hiddenByDefault: true },
        { text: t("app.offlineLicenses"), url: "/licenses/NLM", requiredRole: Roles.Admin },
        { text: t("app.webUpdates"), url: "/system/web-updates" }
      ]
    }, {
      text: t("app.reports"),
      icon: <Icon className='material-icons-outlined' color="action">description</Icon>,
      defaultOpen: true,
      id: "3",
      requiredRole: Roles.User,
      subCategories: [
        { text: t("app.newSales"), url: "/reports/new-sales", hiddenByDefault: true },
        { text: t("app.renewals"), url: "/reports/renewals", hiddenByDefault: true },
        { text: t("licenseUsageSummary.title"), url: "/reports/license-usage" },
        { text: t("app.userSupport"), url: "/reports/support" },
        { text: t("app.churn"), url: "/reports/monthly-reports", hiddenByDefault: true },
      ]
    }, {
      text: t("app.graphs"),
      hiddenByDefault: true,
      icon: <Icon className='material-icons-outlined' color="action">leaderboard</Icon>,
      defaultOpen: true,
      id: "4",
      requiredRole: Roles.User,
      subCategories: [
        { text: t("app.licenseUsage"), url: "/charts/licenseUsage" },
        { text: t("app.sale"), url: "/charts/sales" },
        { text: t("app.churn"), url: "/charts/churn" },
      ]
    },
    {
      text: t("mainMenu.administration"),
      icon: <Icon color="primary">manage_accounts</Icon>,
      defaultOpen: true,
      id: "6",
      requiredRole: Roles.User,
      subCategories: [
        { text: t("app.licenses"), url: "/admin/licenses", hiddenByDefault: true },
        { text: t("app.contracts"), url: "/admin/contracts", hiddenByDefault: true },
        { text: t("app.users"), url: "/admin/users", hiddenByDefault: true },
        { text: t("app.company"), url: "/admin/company", requiredRole: Roles.Admin, hiddenByDefault: true },
        { text: t("app.futureRenewals"), url: "/admin/future-renewals", hiddenByDefault: true },
        { text: t("app.requests"), url: "/admin/company-requests" },
        { text: t("app.productStructure"), url: "/other/product-structure", requiredRole: Roles.Admin },
        { text: t("app.productVersion"), url: "/other/product-version", requiredRole: Roles.ProductResponsible },
        { text: t("app.emails"), url: "/other/email/" },
        { text: "Brønnøysund", url: "/admin/bronnoysund", requiredRole: Roles.Admin, hiddenByDefault: true },
        { text: "GPT", url: "/admin/gpt", requiredRole: Roles.Admin, hiddenByDefault: true }

      ]
    },
    {
      text: t("mainMenu.troubleshooting"),
      icon: <Icon color="primary">build</Icon>,
      defaultOpen: true,
      id: "8",
      requiredRole: Roles.User,
      subCategories: [
        { text: t("app.failedOrders"), url: "/admin/failed-orders" },
        { text: t("app.accountReconciliation"), url: "/admin/account-reconciliation", requiredRole: Roles.Admin },
        { text: t("app.checkFocusAccount"), url: "/other/validate-email" },
        { text: t("app.myPageStatus"), url: "/admin/mypage-status", requiredRole: Roles.Admin },
        { text: t("app.secretPages"), url: "/admin/secretpage", requiredRole: Roles.Admin }
      ]
    },
    {
      text: t("mainMenu.courseAdministration"),
      icon: <Icon color="secondary">manage_accounts</Icon>,
      defaultOpen: true,
      id: "7",
      requiredRole: Roles.User,
      subCategories: [
        { text: t("app.course"), url: "/other/courses" },
        { text: t("app.courseCatalog"), url: "/course-admin/catalog", requiredRole: Roles.Admin },
        { text: t("app.courseList"), url: "/course-admin/course", requiredRole: Roles.Admin },
        // Todo::
        // { text: t("app.courseEvaluation"), url: "https://surveystatistics.azurewebsites.net" },
        { text: t("app.resources"), url: "/course-admin/resources", requiredRole: Roles.Admin },
        { text: t("app.informationTexts"), url: "/course-admin/information-texts", requiredRole: Roles.Admin },
        { text: t("app.emailTemplates"), url: "/course-admin/emailtemplates", requiredRole: Roles.Admin },
        { text: t("app.reports"), url: "/course-admin/reports", requiredRole: Roles.Admin }
      ]
    }
  ]);

  const currentYear: number = new Date().getFullYear();
  return <>
    <Paper
      elevation={0}
      component="div"
      className={`${styles.leftsideMenu} d-none d-lg-block`}>

      <MainMenu
        menuItems={menuItems}
        showHiddenItems={showHiddenItems}
        onShowHiddenItemsChange={setShowHiddenItems}
        currentCompanyNumber={GetCurrentCompany()?.number}
      />
    </Paper>

    <div className={styles.customContentPage}>
      <Routes>
        <Route path='*' element={<Navigate to="overview" />} />
        {CreateRoute("/overview", <Overview />, userRoles)}
        {CreateRoute("/customers/details/*", <CustomerDetails />, userRoles)}
        {CreateRoute("/customers/all-contracts/*", <AllContracts salesforceBaseUrl={environment.salesforce_url} />, userRoles)}
        {CreateRoute("/admin/contract/:contractNumber", <AdminChangeContract />, userRoles, Roles.Admin)}
        {CreateRoute("/customers/support/*", <Support />, userRoles)}
        {CreateRoute("/customers/product-list/*", <CustomerProductList salesforceBaseUrl={environment.salesforce_url} />, userRoles)}
        {/* {CreateRoute("/customers/opportunities/*", <AutodeskOpportunities />, userRole)} */}


        {CreateRoute("/customers/contracts/:contractNumber",
          <ContractDetailsContainer salesforceBaseUrl={environment.salesforce_url} />, userRoles)}
        {CreateRoute("/customers/contracts/new", <NewContractContainer />, userRoles, Roles.Admin)}
        {CreateRoute("/customers/proposals/", < SalesPersonOverviewContainer />, userRoles)}
        {CreateRoute("/customers/proposal/:proposalId/", <SalesOffer />, userRoles)}
        {CreateRoute("/customers/assetSync", <SalesForceAssetSync />, userRoles)}

        {CreateRoute("/licenses/active-users/*", <ActiveUsers />, userRoles)}
        {CreateRoute("/licenses/failed-login/*", <FailedLogin />, userRoles)}
        {CreateRoute("/licenses/rejected-login/*", <RejectedLogin />, userRoles)}
        {CreateRoute("/licenses/license-usage/*", <LicenseUsage />, userRoles)}
        {CreateRoute("/licenses/person-activity/*", <PersonActivity />, userRoles)}
        {CreateRoute("/licenses/license-changes/*", <ExpiredLicense />, userRoles)}
        {CreateRoute("/licenses/license-access/*", <LicenseAccess />, userRoles)}
        {CreateRoute("/licenses/NLM/*", <Nlm />, userRoles, Roles.Admin)}

        {CreateRoute("/system/web-updates/*", <WebUpdates />, userRoles)}

        {CreateRoute("/reports/new-sales/*", <NewSales />, userRoles)}
        {CreateRoute("/reports/renewals/*", <Renewals />, userRoles)}
        {CreateRoute("/reports/license-usage", <LicenseUsageSummary />, userRoles)}
        {CreateRoute("/reports/support/*", <SupportReport />, userRoles)}
        {CreateRoute("/reports/monthly-reports", <MonthlyReportContainer />, userRoles)}

        {CreateRoute("/charts/licenseUsage/", <ProductUsageChart />, userRoles)}
        {CreateRoute("/charts/sales", <SalesChart />, userRoles)}
        {CreateRoute("/charts/churn", <ChurnChart />, userRoles)}

        {CreateRoute("/other/product-structure/*", <ProductStructure />, userRoles, Roles.Admin)}
        {CreateRoute("/other/product-version/*", <ProductVersion />, userRoles, Roles.ProductResponsible)}
        {CreateRoute("/other/courses/*", <Courses />, userRoles)}
        {CreateRoute("/other/validate-email/*", <ValidateEmail />, userRoles)}
        {CreateRoute("/other/email/new", <CreateEmail />, userRoles)}
        {CreateRoute("/other/email/:templateId", <EditEmail />, userRoles)}
        {CreateRoute("/other/email/", <EmailContainer />, userRoles)}


        {CreateRoute("/admin/licenses/*", <Licenses />, userRoles)}
        {CreateRoute("/admin/contracts/*", <Contracts />, userRoles)}
        {CreateRoute("/admin/users/*", <Users />, userRoles)}
        {CreateRoute("/admin/company/*", <AdminCompany />, userRoles, Roles.Admin)}
        {CreateRoute("/admin/company-requests/*", <CompanyRequests />, userRoles)}
        {CreateRoute("/admin/future-renewals/*", <FutureRenewals />, userRoles)}
        {CreateRoute("/admin/mypage-status/*", <MinSideStatus />, userRoles, Roles.Admin)}
        {CreateRoute("/admin/secretpage", <SecretPage1 />, userRoles, Roles.Admin)}
        {CreateRoute("/admin/bronnoysund/*", <BronnoysundAdmin />, userRoles, Roles.Admin)}
        {CreateRoute("/admin/gpt", <GPTOverview />, userRoles, Roles.Admin)}
        {CreateRoute("/admin/failed-orders/*", <SalesForceFailedOrders />, userRoles)}
        {CreateRoute("/admin/account-reconciliation", <SalesForceAccountReconciliationPage />, userRoles, Roles.Admin)}

        {CreateRoute("/course-admin/catalog/*", <Catalog />, userRoles, Roles.Admin)}
        {CreateRoute("/course-admin/course/*", <Course />, userRoles, Roles.Admin)}
        {CreateRoute("/course-admin/resources/*", <Resources />, userRoles, Roles.Admin)}
        {CreateRoute("/course-admin/information-texts/*", <InformationTexts />, userRoles, Roles.Admin)}
        {CreateRoute("/course-admin/course/registrasions/:courseId", <Registration />, userRoles, Roles.Admin)}
        {CreateRoute("/course-admin/emailtemplates/*", <EmailTemplates />, userRoles, Roles.Admin)}
        {CreateRoute("/course-admin/reports/*", <Reports />, userRoles, Roles.Admin)}

        {CreateRoute("/charts/licenseUsage/", <ProductUsageChart />, userRoles)}
        {CreateRoute("/charts/sales", <SalesChart />, userRoles)}
        {CreateRoute("/charts/churn", <ChurnChart />, userRoles)}

      </Routes>

      <footer className={styles.mainFooter}>
        © {currentYear} Sogelink Norway AS. Med enerett.
      </footer>
    </div>

    <Drawer
      anchor='left'
      open={props.drawerOpen}
      onClose={props.onToggleDrawer}>
      {<Box
        sx={{ width: 250 }}>
        <MainMenu
          menuItems={menuItems}
          showHiddenItems={showHiddenItems}
          onShowHiddenItemsChange={setShowHiddenItems}
          currentCompanyNumber={GetCurrentCompany()?.number}
        />
      </Box>}
    </Drawer>
  </>
}

export default App;